(async () => {
  const {
    loadScript,
    loadStyle
  } = await import(window.theme.modules.utils);
  const baseComponent = await import(window.theme.modules.baseComponent);
  // const Swiper = await import(window.theme.modules.swiper);

  customElements.define('press-slider', class extends baseComponent.default {
    elements = {
      sliderContainer: '[data-slider-container]',
      nextButton: '[data-slider-button-next]',
      prevButton: '[data-slider-button-prev]'
    };

    async render() {
      await this._initSwiper();
      
      const navigation = {
        nextEl: this.$nextButton,
        prevEl: this.$prevButton
      };
      
      this.swiper = new window.Swiper(this.$sliderContainer, {
        slidesPerView: 1,
        navigation: navigation
      });
    };
    
    async _initSwiper() {
      await loadStyle(window.theme.styles.Swiper);
      await loadScript(window.theme.scripts.Swiper, 'swiper');
    };

  });
})();